import React from "react";
import {
  Wrench,
  Gauge,
  Bell,
  FileText,
  Users,
  Shield,
  BarChart,
  Settings,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "Smart Metering Systems",
    description:
      "Build IoT-enabled metering solutions for water, gas, and electricity",
    icon: Gauge,
  },
  {
    title: "Billing & Invoicing",
    description: "Develop automated billing systems with usage-based pricing",
    icon: FileText,
  },
  {
    title: "Customer Portals",
    description:
      "Create self-service portals for account management and payments",
    icon: Users,
  },
  {
    title: "Outage Management",
    description: "Build real-time outage detection and notification systems",
    icon: Bell,
  },
  {
    title: "Field Service Apps",
    description: "Mobile solutions for technicians and field operations",
    icon: Wrench,
  },
  {
    title: "Asset Management",
    description: "Track and maintain utility infrastructure efficiently",
    icon: Settings,
  },
  {
    title: "Regulatory Compliance",
    description: "Ensure adherence to utility industry regulations",
    icon: Shield,
  },
  {
    title: "Analytics & Reporting",
    description:
      "Comprehensive dashboards for operations and customer insights",
    icon: BarChart,
  },
];

const STATS = [
  { value: "20M+", label: "Meters Connected" },
  { value: "50+", label: "Utility Clients" },
  { value: "35%", label: "Cost Savings" },
  { value: "Real-time", label: "Monitoring" },
];

const UtilityIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="utility"
      industryTitle="Utility"
      industrySubtitle="Services"
      heroDescription="Modernizing utility operations with smart metering, customer management, and field service solutions that improve efficiency and customer satisfaction."
      themeColor="#64748b"
      themeColorLight="#94a3b8"
      themeGradient="linear-gradient(135deg, #1e293b 0%, #334155 50%, #64748b 100%)"
      HeroIcon={Wrench}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1735825764478-674bb8df9d4a?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default UtilityIndustryPage;
